import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {Segment, Icon, Divider, Input, TextArea, Button} from 'semantic-ui-react';
import L from 'leaflet';
import { deleteAllLayers } from "../../../modules/surveys";
import { LAYER_STYLES } from "../Map";

class Detail extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            response: props.response
        }
    }

    componentDidMount() {
        const {response, getResponse, map} = this.props
        getResponse(response.id).then(response => {
            response.data.geometries.forEach(geom => map.drawLayer.addLayer(L.geoJSON(geom.geom, {style: LAYER_STYLES.default})));
            map.fitBounds(map.drawLayer.getBounds())
            this.setState({response: response.data})
        })
    }

    componentWillUnmount() {
        this.props.map.drawLayer.clearLayers();
        this.props.deleteAllLayers()
    }

    generateDetail(response) {
        let output = []
        let generateJSX = (fieldInfo, group = null) => {
            let type = fieldInfo.type
            const id = (group) ? `${group}:${fieldInfo.id}` : fieldInfo.id
            if (!response[id]) {
                return
            }
            return (
                <div key={id} className="text-bottom-margin">
                    <b>{gettext(fieldInfo.args.label || fieldInfo.args.id || "label missing")}: </b>
                    {Array.isArray(response[id]) ?
                        response[id].join(", ")
                        :
                        type === "email" ?
                            <a href={`mailto:${response[id]}`}>{response[id]}</a>
                            :
                            response[id] || null
                    }
                </div>
            )
        }
        this.props.survey.forEach(field => {
            if (field.fields && field.fields.length) {
                output.push(<h3 className='section-header-divider' key={`header-${field.label}`}>{field.label}</h3>)
                output.push(<div key={`section-${field.id}`} className="section">{field.fields.map(f => generateJSX(f, field.id))}</div>)
            } else if (field) {
                output.push(<div key={`section-${field.id}`} className="section">{generateJSX(field)}</div>)
            }
        })
        return output
    }

    render() {
        const response = this.state.response;
        return (
            <div id="SidebarContent">
                <Segment className="text-dark-gray" style={{minHeight: '100%'}}>
                    <div className="container-space-between">
                        <a onClick={() => this.props.onBack()}>
                            <Button onClick={this.handleNewResponseClick}>
                                <Icon name="reply"/>
                                {gettext('All Projects')}
                            </Button>
                        </a>
                        {
                            (this.props.response.owner_id === this.props.userId) ?
                                <a onClick={() => this.props.onEdit(response)}>
                                    <Button onClick={this.handleNewResponseClick}>
                                        <Icon name="edit" />
                                        {gettext('Edit')}
                                    </Button>
                                </a> : null
                        }
                    </div>
                    <h3 className="section-header-divider">Overview</h3>
                    {this.generateDetail(response.field_data)}
                    { response.documents && response.documents.length > 0 ?
                        <div style={{paddingTop: "10px"}}>
                            <h3 className="section-header-divider">Documents</h3>
                            {response.documents.map(doc => {
                                return <div key={doc.file} className="documents"><a target="_blank" href={doc.file}><Icon name="file"/>{doc.name}</a></div>
                            })}
                        </div>
                        :
                        null
                    }
                </Segment>
            </div>
        );
    }
}


Detail.propTypes = {
    slug: PropTypes.string,
    response: PropTypes.object.isRequired,
    onBack: PropTypes.func.isRequired,
    onEdit: PropTypes.func.isRequired,
    map: PropTypes.instanceOf(L.Map),
    userId: PropTypes.string,
    getResponse: PropTypes.func.isRequired
};

Detail.defaultProps = {
    slug: null,
    map: null,
    userId: null
};

const mapStateToProps = state => ({userId: state.getIn(['people', 'userId'])});

export default connect(mapStateToProps, { deleteAllLayers })(Detail);



// WEBPACK FOOTER //
// ./source/containers/Surveys/Sidebar/Detail.jsx